import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IAuthState } from '~/models'
import { isJsonString } from '~/utils'
import { RootState } from '../../../app/store'
import { LocalStorageKeys } from '~/constants/localStorageKeys'
import { authApis } from '~/api'
const defaultIAuth = {
  userName: null,
  fullName: null,
  roles: [],
  token: null,
  refreshToken : null,
  profilePictureUrl: undefined,
  errorCode : 0,
  isExplicitLogout: false
};

const readStorage = (): IAuthState => {
  const storageString = localStorage.getItem(LocalStorageKeys.user)
  if (isJsonString(storageString as string)) {
    return JSON.parse(storageString as string) as IAuthState;
  }
  return defaultIAuth;
}

const initialState: IAuthState = readStorage();

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IAuthState>) => {
      // Check if profile picture url is a null string ('SgAAAA)
      const profilePicture = action.payload.profilePictureUrl?.includes('SgAAAA')
        ? undefined
        : action.payload.profilePictureUrl
      localStorage.setItem(
        LocalStorageKeys.user,
        JSON.stringify({ ...action.payload, profilePictureUrl: profilePicture })
      )
      state.fullName = action.payload.fullName
      state.roles = action.payload.roles
      state.token = action.payload.token
      state.userName = action.payload.userName
      state.refreshToken = action.payload.refreshToken
      state.profilePictureUrl = profilePicture
      state.errorCode = action.payload.errorCode
      state.isExplicitLogout = false
    },
    logout: (state, action: PayloadAction<{ explicit?: boolean } | undefined>) => {
      authApis.logoutUser({ refreshToken: state.refreshToken, userName: state.userName })
        .catch(() => { })//Swallow here because our local session is not connected to the server session
        .finally(() => localStorage.removeItem(LocalStorageKeys.user));
      state.userName = null
      state.fullName = null
      state.roles = []
      state.token = null
      state.refreshToken = null
      state.profilePictureUrl = undefined
      state.errorCode = 0
      state.isExplicitLogout = !!action.payload?.explicit
    }
  }
})

export const selectAuth = (state: RootState) => state.auth

export const { setUser, logout } = authSlice.actions

export default authSlice.reducer
